import { useLayoutEffect, useRef, type ReactNode } from "react";

import { useShellLayout } from "../context";
import { cx } from "../cx";
import { DOM_IDS, resolveGridTemplate } from "../defaults";

// CircleAIAppShell is v4-only, so the dark: swap below is unconditional
// rather than gated on isCircleV4.
export const GridBody = ({ children }: Readonly<{ children: ReactNode }>) => {
  const { conversationPanelState } = useShellLayout();
  const hasCommitted = useRef(false);

  useLayoutEffect(() => {
    hasCommitted.current = true;
  }, []);

  return (
    <div
      id={DOM_IDS.shellBody}
      data-testid="circle-ai-shell-layout-grid"
      style={{
        gridTemplateColumns: resolveGridTemplate(conversationPanelState),
      }}
      className={cx(
        "group/shell grid min-h-0 flex-1 grid-rows-[1fr] overflow-hidden bg-primary dark:bg-secondary",
        {
          "[transition:grid-template-columns_280ms_cubic-bezier(0.77,0,0.175,1)] motion-reduce:transition-none":
            hasCommitted.current,
        },
      )}
    >
      {children}
    </div>
  );
};
